import React from "react"

import Image from "gatsby-image"

const Curso = ({ orden, imagen, titulo, descripcion, videos, duracion }) => {
  if (!imagen) return null

  return (
    <li className="curso">
      <div className="imagen">
        <p className="orden">{orden} </p>
        <Image fluid={imagen} />
      </div>
      <div className="contenido-curso">
        <h3>{titulo}</h3>
        <div className="meta-curso">
          <p>{videos} Videos</p>
          <p>Duración: {duracion} Horas</p>
        </div>
        <p>{descripcion}</p>
      </div>
    </li>
  )
}

export default Curso
